var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaffRequestResourcePageIcons1 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0039,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_50334_80295)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.6373 11.1264L16.6417 13.7112L17.5544 17.5768C17.6047 17.7867 17.5918 18.0067 17.5171 18.2092C17.4425 18.4117 17.3095 18.5875 17.135 18.7144C16.9604 18.8414 16.7522 18.9137 16.5366 18.9224C16.3209 18.931 16.1076 18.8756 15.9235 18.7631L12.5618 16.6941L9.19809 18.7631C9.01398 18.875 8.80088 18.9299 8.58562 18.9209C8.37036 18.9119 8.16257 18.8395 7.98841 18.7126C7.81426 18.5858 7.68152 18.4103 7.60691 18.2082C7.53231 18.006 7.51918 17.7864 7.56917 17.5768L8.48514 13.7112L5.48958 11.1264C5.32669 10.9856 5.20888 10.7999 5.15087 10.5926C5.09286 10.3853 5.09722 10.1654 5.16341 9.96054C5.22959 9.75567 5.35467 9.57483 5.52302 9.44061C5.69137 9.3064 5.89552 9.22476 6.11 9.20588L10.0375 8.88902L11.5526 5.22245C11.6346 5.02262 11.7742 4.8517 11.9536 4.7314C12.133 4.61111 12.3441 4.54688 12.5601 4.54688C12.7761 4.54688 12.9872 4.61111 13.1666 4.7314C13.346 4.8517 13.4856 5.02262 13.5676 5.22245L15.082 8.88902L19.0096 9.20588C19.2244 9.22405 19.4292 9.30524 19.5982 9.43927C19.7671 9.5733 19.8928 9.75421 19.9594 9.95933C20.026 10.1645 20.0306 10.3847 19.9725 10.5924C19.9145 10.8001 19.7965 10.9861 19.6333 11.127L19.6373 11.1264Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_50334_80295",
  x1: 6.50391,
  y1: 1,
  x2: 16.0039,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFC1ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0DDFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaffRequestResourcePageIcons1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staff_request_resource_page_icons1.6a7c01d14ab120c900873b96ae2f5c57.svg";